import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsEvaluatorHealthUnit,
  FiltersNpsEvaluatorHealthUnits
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsEvaluatorHealthUnitResponse,
  ListNpsEvaluatorHealthUnitsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsEvaluatorHealthUnitService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/evaluator-health-units'
  }

  async create(payload: CreateNpsEvaluatorHealthUnit): Promise<NpsEvaluatorHealthUnitResponse> {
    const response = await request.post<NpsEvaluatorHealthUnitResponse>(
      this.getCompletePath(),
      payload
    )
    return response.data
  }

  async getById(id: number): Promise<NpsEvaluatorHealthUnitResponse> {
    const response = await request.get<NpsEvaluatorHealthUnitResponse>(
      `${this.getCompletePath()}/${id}`
    )
    return response.data
  }

  async delete(id: number): Promise<void> {
    await request.delete(`${this.getCompletePath()}/${id}`)
  }

  async list(
    filters?: FiltersNpsEvaluatorHealthUnits
  ): Promise<ListNpsEvaluatorHealthUnitsResponse> {
    try {
      const { data } = await request.get<ListNpsEvaluatorHealthUnitsResponse>(
        this.getCompletePath(),
        filters
      )
      return data
    } catch (e) {
      return {
        count: 0,
        data: []
      }
    }
  }
}
